import React, { Component } from 'react'
import { Form, Input } from 'antd';

const { TextArea } = Input;

export class ContractNote extends Component {

    render() {
        const { unlimitEdit, isDriverless } = this.props;
        return <>
            <div className="title-contract title-special">{`${isDriverless ? '11' : '12'}. Ghi chú`}</div>
            <Form.Item
                wrapperCol={24}
                name={'note'}
                className="note"
                >
                <TextArea disabled={!unlimitEdit} style={{ height: '70px !important'}} rows={8}/>
            </Form.Item>
        </>
    }
}
